import { VALIDITY_STATUS, getMaintenanceExpiry } from '../../helpers/ExpiryRule';
import { getAddonsAlert } from '../../helpers/AddonValidity';
import { isSoftwareOnlyTrial } from '../../helpers/Maintenance';

// react-bootstrap-table-next only re-renders a formatter cell when the row object itself changes, so every
// per-row value the cells show lives on the row. `expirationDate` is also the sortable value of the Expiration
// Date column and `addonsAlert` the one of the Licenses column (each a unique `field`, so compass can tell the
// sortable columns apart). The maintenance comes from the batch product, like the licenses, so the Expiration
// Date and the Trial badge fill in once the batch has returned.
export const buildTableMachine = (machine, { enrollment, product, interval }) => {
	const maintenanceExpiry = getMaintenanceExpiry(product?.maintenance?.expiresOn, interval);

	return {
		...machine,
		partnerPreviewEnrollment: enrollment || null,
		currentUpgradeChannel: product?.currentUpgradeChannel ?? null,
		expirationDate: maintenanceExpiry?.calendarDate ?? null,
		maintenanceExpiringInDays: maintenanceExpiry?.status === VALIDITY_STATUS.EXPIRING ? maintenanceExpiry.daysLeft : null,
		isSoftwareOnlyTrial: isSoftwareOnlyTrial(product?.maintenance),
		addonsAlert: getAddonsAlert(product?.productAddons, interval),
	};
};
